import {
    Avatar,
    Grid,
    Typography,
    InputLabel,
    Checkbox,
    FormControlLabel,
    Button,
    Input,
    Backdrop,
    TextField,
    LinearProgress,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { useEffect, useState } from 'react';
import config from '../config.json';

const PREFIX = 'ChooseProfile';

const classes = {
    backdrop: `${PREFIX}-backdrop`,
    menuButton: `${PREFIX}-menuButton`,
    avatar: `${PREFIX}-avatar`,
    paper: `${PREFIX}-paper`,
    submit: `${PREFIX}-submit`,
    form: `${PREFIX}-form`,
    mobileChildUser: `${PREFIX}-mobileChildUser`,
    laptopChildUser: `${PREFIX}-laptopChildUser`
};

const Root = styled('div')((
    {
        theme
    }
) => ({
    [`& .${classes.backdrop}`]: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },

    [`& .${classes.menuButton}`]: {
        fontFamily: 'Open Sans, sans-serif',
        fontWeight: 800,
        fontSize: 20,
        marginTop: 24,
        color: '#ffffff',
        width: 100,
        textTransform: 'none',
        borderRadius: 20,
    },

    [`& .${classes.avatar}`]: {

        margin: theme.spacing(1),
        height: 50,
        backgroundColor: config[process.env.REACT_APP_HOST_NAME].css.websiteColor,
        width: 50,
        float: 'center',
        alignItems: 'center',
        textAlign: 'center'
    },

    [`& .${classes.paper}`]: {
        marginTop: theme.spacing(15),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        backgroundColor: '#ffffff',
        borderRadius: 20,
        zIndex: 5,

    },

    [`& .${classes.submit}`]: {
        margin: theme.spacing(3, 0, 2),
    },

    [`& .${classes.form}`]: {
        width: '50%', // Fix IE 11 issue.
        marginTop: theme.spacing(3),
        float: 'center'
    },

    [`& .${classes.mobileChildUser}`]: {
        textAlign: 'center', display: 'flex', justifyContent: 'center', width: '50vw', height: '10vh'
    },

    [`& .${classes.laptopChildUser}`]: {
        textAlign: 'center', display: 'flex', justifyContent: 'center', width: '20vw', height: '10vh'
    }
}));

const token = localStorage.getItem('token');
const userID = parseInt(localStorage.getItem('userID'));
const parentID = parseInt(localStorage.getItem('parent_id'));
const loggedInUserEmail = localStorage.getItem('email_id');
const parentToken = localStorage.getItem('parent_token');

const StyledAvatar = styled(Avatar)(({ theme }) => ({
    margin: theme.spacing(1),
    height: 50,
    backgroundColor: config[process.env.REACT_APP_HOST_NAME].css.websiteColor,
    width: 50,
    float: 'center',
    alignItems: 'center',
    textAlign: 'center'
}));

function ChooseProfile() {
    const [profiles, setProfiles] = useState([])

    const value = 'offer';
    const [state, setState] = useState({
        checkedA: true,
        checkedB: false,
    });
    const [isLoading, setisLoading] = useState(false);
    const [addClick, setAddClick] = useState(false);
    const [submitHit, setSubmitHit] = useState(false);
    const [parent, setParent] = useState({});

    const [viewState, setViewState] = useState({
        mobileView: false,
    });
    const [childUserCss, setChildUserCss] = useState('laptopChildUser');

    const handleChange = (e) => {

        const { name, value } = e.target
        setState({ ...state, [e.target.name]: e.target.checked });
        updateFormData({
            ...formData,
            // Trimming any whitespace
            [e.target.name]: e.target.value.trim(),
        });


        let formErr = formErrors;
        switch (name) {
            case 'first_name':
                formErr.first_name = (value.length < 3 && value.length > 0) ? "Please enter your first name" : "";
                break;
            case 'last_name':
                formErr.last_name = (value.length < 3 && value.length > 0) ? "Please enter your last name" : "";
                break;
            case 'password':
                formErr.password = (value.length < 6 && value.length > 0) ? "Minimum 6 characters" : "";
                break;
            case 'confirm_password':
                formErr.confirm_password = (value === (formData.password)) ? "" : "Both passwords don't match";
                break;
            case 'mobile_number':
                formErr.mobile_number = (value.length < 10 || value.length > 10) ? "Mobile Number should be 10 digits" : "";
                break;
            default:
                break;
        }

        updateFormErrors(formErr);

    };

    const initialFormData = Object.freeze({
        email_id: '',
        password: '',
        confirm_password: '',
        dob: "",
        first_name: '',
        last_name: '',
        mobile_number: '',
        linkedin_url: '',

    });


    const iformErrors = {
        first_name: '',
        last_name: '',
        password: '',
        dob: '',
        confirm_password: '',
        mobile_number: ''
    };

    const [formData, updateFormData] = useState(initialFormData);
    const [formErrors, updateFormErrors] = useState(iformErrors);

    const addProfile = async () => {

        if (!formData.email_id) {
            formData.email_id = loggedInUserEmail;
        }

        const body = {
            first_name: formData.first_name,
            last_name: formData.last_name,
            dob: formData.dob ? formData.dob : null,
            mobile_number: formData.mobile_number,
            email_id: formData.email_id,
            user_uuid: (formData.first_name + formData.last_name.charAt(0)).replace(/ /g, '_').toLowerCase(),
            password: formData.password,
            above_age: state.checkedA,
            account_type: value,
            linkedin_url: formData.linkedin_url,
            domain: window.location.hostname,
            logged_in_user_email: loggedInUserEmail
        }

        setSubmitHit(true);

        if (formData.first_name && formData.last_name) {
            setisLoading(true);
            try {
                await fetch(process.env.REACT_APP_API_URL + '/api/user/register/', {
                    method: "POST",
                    headers: {
                        "Content-Type": 'application/json',
                    },
                    body: JSON.stringify(body),
                })
                setisLoading(false);
                setAddClick(false);
                getProfiles();
            } catch (err) {
                setisLoading(false);
                setAddClick(false);
            }
        }

    }

    const selectProfile = async (id, fn, email_id) => {
        try {

            const body = {
                "parentToken": parentToken,
                "selectedProfileId": id
            };

            const rawResponse = await fetch(process.env.REACT_APP_API_URL + '/api/user/profile/login/', {
                method: "POST",
                headers: {
                    "Authorization": `Token ${token}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(body),
            })

            let loginResponse = await rawResponse.json()
            // console.log(loginResponse)
            if (loginResponse && loginResponse.data && loginResponse.data.token) {

                const userDetails = loginResponse.data
                localStorage.setItem('token', userDetails.token);
                localStorage.setItem('userID', userDetails.id);
                localStorage.setItem('first_name', userDetails.first_name);
                localStorage.setItem('email_id', userDetails.email_id);
                const localUserDetails = { first_name: userDetails['first_name'], last_name: userDetails['last_name'], profile_pic: userDetails['profile_pic'], created_at: userDetails['created_at'] };
                localStorage.setItem('user', JSON.stringify(localUserDetails));
                window.location.href = '/dashboard'

            } else {
                window.location.href = '/'
            }

        } catch (err) {
            window.location.href = '/'
        }

    }

    const getProfiles = async () => {
        try {
            fetch(
                process.env.REACT_APP_API_URL + `/api/user/list/profile/${parentID}`,
                {
                    method: 'GET',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Token ${token}`
                    },
                }
            )
                .then((res) => res.json())
                .then((data) => {

                    setParent(data.data.parentUser)
                    setResponsiveness();
                    if (viewState.mobileView) {
                        setChildUserCss('mobileChildUser');
                    }
                    setProfiles(data.data.childUsers);

                }).catch(err => {
                    //console.log(err)
                });
        } catch (error) {

        }
    }

    const setResponsiveness = () => {
        return window.innerWidth < 900
            ? setChildUserCss('mobileChildUser')
            : setViewState((prevState) => ({ mobileView: false }));
    };

    useEffect(() => {

        setResponsiveness();
        getProfiles();
        // eslint-disable-next-line
    }, []);

    if (!isLoading) {
        return (
            <Grid>
                <Grid>
                    <Typography variant="h3" style={{ paddingTop: '20px', textAlign: 'center' }}>
                        Welcome to your {process.env.REACT_APP_TITLE} family account
                    </Typography>
                    <Typography variant="h6" style={{ paddingTop: '20px', textAlign: 'center' }}>
                        Choose a profile
                    </Typography>
                    <Root style={{ paddingTop: '5.5vh' }}>
                        <Grid item xs={12} sm={1} md={12} style={{ textAlign: 'center', display: 'flex', justifyContent: 'center' }} >
                            <StyledAvatar variant="square" style={{ width: '10vh', height: '10vh', fontSize: '7vh', border: parent.id === userID ? `2px solid  ${config[process.env.REACT_APP_HOST_NAME].css.websiteColor}` : "" }} src={parent.profile_pic} onClick={() => { selectProfile(parent.id, parent.first_name, parent.email_id) }}></StyledAvatar>
                        </Grid>
                        <Typography style={{ paddingTop: '10px', textAlign: 'center' }}>
                            {parent.first_name}   {parent.last_name}
                        </Typography>
                    </Root>
                </Grid>
                <Grid container direction="row" style={{ paddingTop: '5vh', display: 'flex', justifyContent: 'center' }}>
                    {profiles.map(p =>
                        <div key={p.id}>
                            <Grid item xs={12} sm={6} md={12} className={classes[childUserCss]} >
                                <StyledAvatar variant="square" style={{ width: childUserCss === 'mobileChildUser' ? '20vw' : '10vw', height: '10vh', border: p.id === userID ? `2px solid  ${config[process.env.REACT_APP_HOST_NAME].css.websiteColor}` : "" }} src={p.profile_pic} onClick={() => { selectProfile(p.id, p.first_name, p.email_id) }}></StyledAvatar>
                            </Grid>
                            <Grid item xs={12} sm={6} md={12} className={classes[childUserCss]}  >
                                <Typography style={{ paddingTop: '10px', textAlign: 'center' }}>
                                    {p.first_name}   {p.last_name}
                                </Typography>
                            </Grid>
                        </div>
                    )}
                </Grid>
                <div style={{ paddingTop: '5vh' }}>
                    <Grid item xs={12} sm={1} md={12} style={{ textAlign: 'center', justifyContent: 'center', alignItems: 'center' }}>
                        <div style={{ justifyContent: 'center', display: 'flex' }}>
                            <StyledAvatar variant="square" style={{ width: '10vh', height: '10vh', fontSize: '7vh' }} onClick={() => { setAddClick(true) }}>+</StyledAvatar>
                        </div>
                        <Typography style={{ paddingTop: '10px' }}>
                            Add Profile
                        </Typography>
                        <Backdrop className={classes.backdrop} open={addClick}  >
                            <Grid container spacing={1} justifyContent='center' style={{
                                backgroundColor: '#ffffff',
                                color: 'black',
                                textAlign: 'left',
                                zIndex: 10,
                                width: childUserCss === 'mobileChildUser' ? '85%' : '50%'
                            }} >
                                <Grid container spacing={2} justifyContent='center' style={{ paddingTop: '2vh' }} >
                                    <Grid item xs={10} md={3} style={{ textAlign: 'center' }}>
                                        <InputLabel style={{ textAlign: 'left' }}>First Name</InputLabel>
                                        <Input
                                            variant="outlined"
                                            required={true}
                                            fullWidth
                                            name="first_name"
                                            label="First Name"
                                            type="FirstName"
                                            id="first_name"
                                            onChange={handleChange}
                                            error={submitHit && formData.first_name.length === 0}
                                        />

                                    </Grid>
                                    <Grid item xs={10} md={3} style={{ textAlign: 'center' }}>
                                        <InputLabel style={{ textAlign: 'left' }}>Last Name</InputLabel>
                                        <Input
                                            variant="outlined"
                                            required={true}
                                            fullWidth
                                            name="last_name"
                                            label="Last Name"
                                            type="LastName"
                                            id="LastName"
                                            onChange={handleChange}
                                            error={submitHit && formData.last_name.length === 0}
                                        />

                                    </Grid>
                                </Grid>
                                <Grid container spacing={2} justifyContent='center' style={{ paddingTop: '2vh' }}>
                                    <Grid item xs={10} md={3}>
                                        <InputLabel style={{ textAlign: 'left' }}>Date of Birth</InputLabel>

                                        <TextField
                                            id="dob"
                                            name="dob"
                                            type="date"
                                            size="small"
                                            fullWidth
                                            variant="outlined"
                                            onChange={handleChange}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            error={submitHit && formData.dob.length === 0}
                                        />
                                    </Grid>
                                    <Grid item xs={10} md={3} style={{ textAlign: 'center' }} >

                                        <InputLabel style={{ textAlign: 'left' }}>Email Address</InputLabel>
                                        <Input
                                            variant="outlined"
                                            required
                                            fullWidth
                                            id="email_id"
                                            label="Email Address"
                                            name="email_id"
                                            autoComplete="email"
                                            onChange={handleChange}
                                            error={submitHit && formData.email_id.length === 0}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2} justifyContent='center' style={{ paddingTop: '2vh' }} >
                                    <Grid item xs={10} md={3} style={{ textAlign: 'center' }}>
                                        <InputLabel style={{ textAlign: 'left' }}> Mobile Number </InputLabel>
                                        <Input
                                            variant="outlined"
                                            required
                                            fullWidth
                                            name="mobile_number"
                                            label="Mobile Number(+91): "
                                            type="tel"
                                            id="MobileNo"
                                            error={submitHit && formData.mobile_number.length === 0}
                                            onChange={handleChange}
                                        />
                                        {formErrors.mobile_number.length > 0 && (
                                            <Grid item xs={10} style={{ textAlign: 'center', marginTop: 16 }}><span className=" ">{formErrors.mobile_number}</span></Grid>
                                        )}

                                    </Grid>
                                </Grid>
                                <Grid item xs={10} md={12} style={{ textAlign: 'center' }} >
                                    <Typography style={{ marginTop: 8, marginBottom: 8, fontFamily: 'Raleway' }}> (If you're below 18, please provide your parent's email id and mobile number)</Typography>
                                </Grid>
                                <Grid item xs={12} md={12} style={{ textAlign: 'center', fontSize: 16 }}>
                                    <FormControlLabel
                                        control={<Checkbox checked={state.checkedB} onChange={handleChange} name="checkedB" style={{ color: config[process.env.REACT_APP_HOST_NAME].css.websiteColor }} />}

                                        style={{ marginTop: 8, color: config[process.env.REACT_APP_HOST_NAME].css.websiteColor }}
                                    />I agree to the <a href='https://drive.google.com/file/d/1tlqy-e1LNcCIEORd-E0xFAeK_HzoWZLL/view?usp=sharing' target='_blank' rel='noopener noreferrer'>Terms and Conditions</a> and <a href='https://drive.google.com/file/d/1N3p9Wr2ksD61Cm1r9vjR0JCKGLRaLGSQ/view?usp=sharing' target='_blank' rel='noopener noreferrer'>Privacy Policy</a>
                                </Grid>
                                <Grid item xs={10} md={12} style={{ textAlign: 'center' }}>
                                    {state.checkedB ?
                                        <Button
                                            type="submit"
                                            variant="contained"
                                            color="primary"
                                            disabled={!state.checkedB}
                                            className={classes.submit}
                                            onClick={addProfile}
                                            style={{ height: 40, backgroundColor: config[process.env.REACT_APP_HOST_NAME].css.buttonColor, color: config[process.env.REACT_APP_HOST_NAME].css.buttonFontColor }}
                                        >
                                            Add Profile
                                        </Button> :
                                        <Button
                                            type="submit"
                                            disabled
                                            variant="contained"

                                            className={classes.submit}
                                            onClick={addProfile}
                                            style={{ height: 40 }}
                                        >
                                            Add Profile
                                        </Button>}
                                    <Grid>
                                        <Button
                                            type="submit"
                                            style={{ height: 40, backgroundColor: config[process.env.REACT_APP_HOST_NAME].css.buttonColor, color: config[process.env.REACT_APP_HOST_NAME].css.buttonFontColor }}
                                            variant="contained"
                                            onClick={() => setAddClick(false)}
                                        >
                                            Cancel
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>

                        </Backdrop>
                    </Grid>
                </div>
            </Grid >
        );
    } else {
        return (
            <div style={{ marginTop: 20, textAlign: "center" }}>
                <img alt={'logo'} style={{ height: 350, width: 300 }} src={`${process.env.REACT_APP_R2_URL}/general/time_creds_logo.png`} />
                <LinearProgress />
            </div>
        );
    }


}

export default ChooseProfile;